export function classByKey(check: any, ifTrue: string, ifFalse?: string) {
  if (!!check) {
    return ifTrue;
  }

  return ifFalse;
}
